<template>
  <div class="w-100 d-flex flex-grow-1">
    <PresentationControl/>
    <SideBar class="d-flex flex-grow-1 bg-dark"  />
    <ConnectionIndicator ></ConnectionIndicator>
  </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex"
    import PreviewSlide from "./PreviewSlide"
    import PresentationControl from "./PresentationControl"
    import visibility from "../../packs/shared/visibility";
    import SideBar from "./sidebar/SideBar"
    import {UniqueChecker} from "../../packs/shared/unique-checker";
    import ConnectionIndicator from "../frontend/shared/ConnectionIndicator";

    export default {
        name: 'Live',
        components: {ConnectionIndicator, SideBar, PresentationControl, PreviewSlide},
        computed: {
            ...mapState(['election', 'slides']),
            ...mapGetters(['activeSlide', "firstAvailableLocale"]),
            ballotSlides(){
                return this.slides.filter(s => s.type === 'Slides::BallotSlide')
            },
            visible(){
              return this.visibility.visible;
            }
        },
        data() {
          return {
            visibility,
            uniqueChecker: new UniqueChecker()
          }
        },
        methods: {
            ...mapActions(['updateStatus', 'updatePosts', 'checkTime', 'fetchLiveResult','ensureLastUpdateCounts', 'checkWebsocketConnection']),
            ...mapMutations(['goToSlide', 'setProgress', 'setResult', 'setBallotState', 'closeBallot', 'resetBallot', 'setCounts', 'createItem', 'updateItem', 'deleteItem']),
        },
        watch: {
          visible: function(newState, oldState){
            if(newState){
              this.updateStatus(true);
              this.updatePosts();
            }
          }
        },
        channels: {
            ElectionsChannel: {
                connected() {
                    this.updateStatus(true);
                    console.log("Connection was made")
                },
                rejected() {
                    console.log("Connection attempt was rejected")
                },
                received(data) {
                    console.log(data)

                    // protect against doubled messages
                    if(data.uuid && this.uniqueChecker.wasSeen(data.uuid)) return console.log("RECEIVED DOUBLE MESSAGE")

                    switch (data.type) {
                        case 'goto':
                            this.goToSlide(data.id);
                            break;
                        case 'create_item':
                            this.createItem({path: data.path, item: data.item})
                            break;
                        case 'update_item':
                            this.updateItem({path: data.path, changes: data.changes})
                            break;
                        case 'delete_item':
                            this.deleteItem(data.path)
                            break;
                        case 'state_change':
                            this.setBallotState({ballotId: data.ballot_id, ballotState: data.state});
                            break;
                        case 'ballot_disable':
                            this.closeBallot({ballotId: data.ballot_id, time: data.time})
                            break;
                        case 'progress':
                            this.setProgress({ballotId: data.ballot_id, progress: data.progress})
                            break;
                        case 'result_ready':
                            this.fetchLiveResult(data.ballot_id)
                            break;
                        case 'reset_ballot':
                            this.resetBallot(data.ballot_id)
                            break;
                        case 'update_counts':
                            this.setCounts(data.voterCounts)
                            this.ensureLastUpdateCounts(data.force)
                            break
                        case 'update':
                            this.updatePosts();
                            this.updateStatus(true);
                            break;
                        default:
                            console.log(`received unknown message ${data.type}; updating election`)
                            this.updateStatus(true);
                            break;
                    }
                },
                disconnected() {
                    console.log("Connection was lost")
                    //attempt reconnect? how much of these kinds of things does vue-actioncable handle?
                },
            }
        },
        created() {
            this.checkTime()
        },
        mounted(){
          this.updateStatus(true)
          this.updatePosts()
          this.$cable.subscribe({
              channel: 'ElectionsChannel',
              election_id: this.election.id,
              slug: this.election.slug });

          this.connectiontimer = setInterval(() => {
            this.checkWebsocketConnection(this.$cable)
          }, 1000)
        },
        beforeDestroy() {
            clearInterval(this.connectiontimer)
        }
    }
</script>